import { Carousel } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';

const cardData = [
  {
    img: '/img/logo/oti.jpg',
    title: 'OTI Foods Products Ltd',
    link: '/otifoods',
    year: '2021'
  },
  {
    img: '/img/logo/iva.avif',
    title: 'IVA International Group Ltd',
    link: '/',
    year: '2023'
  },
  {
    img: '/img/logo/turca.png',
    title: 'Turca Breakfast Restaurant',
    link: 'https://turca.ca',
    year: '2020'
  },
  // {
  //   img: '/img/logo/sample.png',
  //   title: 'New Partner Company',
  //   link: '#',
  // },
];

const sliderData = [
  {
    img: '/img/factorybg.jpg',
    title: 'Empowering Rural Canada Through Added Value, Infrastructure & Innovation',
    subtitle: '',
  },
  // {
  //   img: '/img/1.png',
  //   title: 'Production Excellence in Edmonton',
  //   subtitle: 'Building Alberta’s future in food manufacturing with Flour Milling, Pasta, and Confectionery production in Edmonton.',
  // },
  // {
  //   img: '/img/ivaFactory.jpg',
  //   title: 'IVA International – Residential & Commercial Development',
  //   subtitle: 'Creating vibrant communities with residential homes, apartment complexes, and essential infrastructure in Acme, Alberta.',
  // },
];

export const Header = (props) => {

  const navigate = useNavigate();
  const [activeIndex, setActiveIndex] = useState(0);
  const [animate, setAnimate] = useState(false);

  useEffect(() => {
    setAnimate(true);
  }, []);

  const onSlideChange = (current) => {
    setActiveIndex(current);
    setAnimate(false);
    setTimeout(() => setAnimate(true), 100);
  };

  return (
    <div>
      <header id="header" style={{ position: 'relative' }}>
        <Carousel
          className='carousel-wrapper'
          arrows
          infinite={false}
          afterChange={onSlideChange}
        >
          {sliderData.map((item, i) => (
            <div key={i}>
              <div style={{ height: '80vh', position: 'relative' }}>
                <img
                  src={item.img}
                  alt={item.title}
                  loading="lazy"
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                    filter: 'brightness(0.6)',
                    objectPosition: 'top'
                  }}
                />
                <div
                  className='linkedin-header'
                  style={{
                    position: 'absolute',
                    bottom: '25px',
                    right: '25px',
                    display: 'flex',
                    gap: '12px',
                    backgroundColor: 'rgba(255, 255, 255, 0.85)',
                    padding: '8px 14px',
                    zIndex: 2,
                  }}
                >
                  <a
                    href="https://www.linkedin.com/company/tahil-group-canada"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ color: '#0077b5', fontSize: '3rem' }}
                  >
                    <i className="fa fa-linkedin"></i>
                  </a>
                </div>

                <div style={{
                  position: 'absolute',
                  backgroundColor: 'rgba(255, 255, 255, 0.1)',
                  top: '20%',
                  left: '10%',
                  color: '#fff',
                  maxWidth: '600px',
                  padding: '20px',
                  pointerEvents: 'none'
                }}>
                  <h1
                    style={{ fontSize: '3.5rem', fontWeight: '900' }}
                    className={animate && activeIndex === i ? 'slideInLeft' : ''}
                  >
                    {item.title}
                  </h1>
                  <p
                    style={{ fontSize: '1.5rem' }}
                    className={animate && activeIndex === i ? 'slideInUp' : ''}
                  >
                    {item.subtitle}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </Carousel>

        {/* Our Companies Box */}
        <div
          className='our-companies-box'
          style={{
            position: 'absolute',
            top: 'calc(100% - 160px)',
            left: '50%',
            transform: 'translateX(-50%)',
            width: '75%',
            backgroundColor: '#fff',
            boxShadow: '0 8px 28px rgba(0,0,0,0.1)',
            padding: '0 0 32px 0',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            zIndex: 1000,
          }}
        >
          <div style={{ backgroundColor: 'rgba(77, 77, 77, 0.1)', width: '100%', display: 'flex', justifyContent: 'center' }}>
            <h2 style={{
              fontSize: '2rem',
              fontWeight: 'bold',
              color: '#C38745',
              marginBottom: '24px',
              textAlign: 'center',
              padding: '0',
              margin: '15px 0',
              animation: 'slideInUp 1s ease forwards'
            }}>
              Our Companies
            </h2>
          </div>

          <div style={{
            display: 'flex',
            justifyContent: 'space-around',
            alignItems: 'stretch',
            flexWrap: 'nowrap',
            width: '100%',
            animation: 'slideInUp 1s ease 0.3s forwards',
            opacity: 0
          }}
            className='companies-cards'
          >
            {cardData.map((card, index) => (
              <div
                key={index}
                className="card-wrapper"
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  textAlign: 'center',
                  cursor: 'pointer',
                  padding: '0 14px',
                  width: '100%',
                  borderRight: index !== cardData.length - 1 ? '1px solid #eee' : 'none',
                  opacity: 0,
                  animation: `slideInUp 0.6s ease forwards`,
                  animationDelay: `${0.4 + index * 0.2}s`
                }}
                onClick={() => {
                  if (card.link.startsWith("/")) {
                    navigate(card.link);
                  } else {
                    window.open(card.link, '_blank');
                  }
                }}
              >
                <img
                  src={card.img}
                  alt={card.title}
                  loading="lazy"
                  style={{ width: 84, height: 84, objectFit: 'contain', marginBottom: 10 }}
                />
                <div style={{ fontWeight: 600, fontSize: 14, marginBottom: 4 }}>{card.title}</div>
                <div style={{ fontSize: 14, color: '#888', fontFamily: "'Playfair Display', serif", fontStyle: 'italic' }}>Since {card.year}</div>
              </div>
            ))}
          </div>
        </div>

        <style>{`
          @keyframes slideInLeft {
            from {
              opacity: 0;
              transform: translateX(-50px);
            }
            to {
              opacity: 1;
              transform: translateX(0);
            }
          }
          @keyframes slideInUp {
            from {
              opacity: 0;
              transform: translateY(30px);
            }
            to {
              opacity: 1;
              transform: translateY(0);
            }
          }
          .slideInLeft {
            animation: slideInLeft 0.8s ease forwards;
          }
          .slideInUp {
            animation: slideInUp 0.8s ease forwards;
          }
          /* Responsive kısımlar mevcut */
          @media (max-width: 768px) {
            .our-companies-box {
              width: 90% !important;
            }
            .card-wrapper {
              padding: 12px !important;
            }
            .card-wrapper img {
              width: 60px !important;
              height: 60px !important;
              margin-bottom: 8px !important;
            }
            .card-wrapper div {
              font-size: 12px !important;
            }
            .our-companies-box h2 {
              font-size: 1.5rem !important;
              margin: 10px 0 !important;
            }
            .header-bottom-text {
              width: 90% !important;
              font-size: 14px !important;
            }
            .logo-header{
              height: 80px!important;
            }
            .linkedin-header{
              bottom: 70px!important;
              right: 20px!important;
            }
          }
        `}</style>
      </header>

      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: 'rgb(249, 250, 251)', flexDirection: 'column', padding: '90px 0 20px 0' }}>
        <p className="header-bottom-text" style={{ textAlign: 'center', width: '67%', lineHeight: 1.8 }}>
          As a proudly Canadian parent company, Tahil Group unites a group of specialized businesses focused on quality food production and community development. OTI Food Products mills premium, additive-free flour at its Alberta facility and plans to expand into pasta and other grain-based foods. IVA International Group Ltd aims to develop modern residential communities and housing infrastructure in rural Alberta. Turca Breakfast & Lunch brings authentic Turkish flavours to Canada with fresh, traditional breakfast and lunch offerings. Together, these companies reflect Tahil Group’s commitment to quality, sustainability, and local growth.
        </p>
        <img
          className='logo-header'
          src="/img/logo/tahil_logo_vector.png"
          alt="Tahıl Logo"
          loading="lazy"
          style={{
            height: '100px',
            margin: '20px'
          }}
        />
      </div>
    </div>
  );
};

export default Header;

